// OfferCard.jsx
import React from "react";
import { useSearchParams } from "react-router-dom";
import { setUserClickData } from "../../../../utility/setUserClickData";

const OfferCard = ({
  offer,
  isExpanded,
  onExpand,
  key,
  setCurrentStep,
  setSelectedOffer,
  leadId,
  failed = false,
}) => {
  const [params] = useSearchParams();
  const handleClick = () => {
    if (failed) return;
    setUserClickData({
      event_name: `offer-selected-multistep-pl-v1-${offer?.lender_name || "unknown"}`,
      user_id: offer?.contact_phone || leadId || "unknown",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || params.get("utm_medium"),
      utm_term: params.get("utm_term"),
    });
    setSelectedOffer(offer);
    setCurrentStep("complete_application");
  };

  // `offer` can be an object (success) or a plain name string (failed list).
  const lenderName =
    (offer && typeof offer === "object" ? offer.lender_name : offer) || "";
  // Logo comes from the DB via get-fail-success-lenders (rect_lender_logo).
  const logoSrc =
    offer?.rect_lender_logo || offer?.banking_partners_hl || offer?.logo_image_url || null;

  // credit_limit (from /api/v1/loan_offer/list) may be a number or a formatted
  // string. Handle both so we never render "₹NaN".
  const formatAmount = (raw) => {
    if (raw == null || raw === "") return "N/A";
    const num = Number(raw);
    if (Number.isFinite(num) && num > 0) return `₹${num.toLocaleString("en-IN")}`;
    const str = String(raw).trim();
    return str.includes("₹") ? str : `₹${str}`;
  };
  const amountDisplay = failed ? "N/A" : formatAmount(offer?.credit_limit);
  const emiDisplay =
    !failed && offer?.emi != null && offer?.emi !== ""
      ? `₹${Number(offer.emi).toLocaleString("en-IN")}`
      : "N/A";
  const tenureDisplay =
    !failed && offer?.tenure != null && offer?.tenure !== ""
      ? `${offer.tenure} Months`
      : "N/A";
  const interestDisplay = failed
    ? "N/A"
    : offer?.interest_rate || (offer?.roi != null ? `${offer.roi}% p.a.` : "—");

  return (
    <div className={"w-full bg-white rounded-[24px] border border-[#ededed] shadow-[0_4px_20px_rgba(0,0,0,0.05)] p-6 mt-3 " + (failed ? "grayscale opacity-70" : "")} key={key}>
      {/* TOP: amount + lender logo + KFS */}
      <div className="flex justify-between items-start">
        <div>
          <p className="font-atkinson text-[12px] text-[#8b8b8b]">Loan Amount</p>
          <p className="font-atkinson font-bold text-[20px] tracking-tight mt-1 text-[#1b1b1b]">
            {amountDisplay}
          </p>
        </div>

        <div className="flex flex-col items-end">
          {logoSrc && (
            <img
              src={logoSrc}
              alt={lenderName || "lender"}
              onError={(e) => { e.currentTarget.style.display = "none"; }}
              className="max-h-[50px] max-w-[140px] object-contain"
            />
          )}
          {!failed && offer?.kfs_doc && (
            <a
              href={offer.kfs_doc}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="flex items-center gap-1 font-atkinson font-semibold text-[8px] text-[#1D65DC]"
            >
              View KFS
              <img
                src={process.env.PUBLIC_URL + "/assets/img/file-remove-1.png"}
                alt="KFS"
                className="w-[10px] h-[10px] object-contain"
              />
            </a>
          )}
        </div>
      </div>

      <div className="h-px bg-[#ededed] my-[18px]" />

      {/* EMI / Tenure / Interest */}
      <div className="flex justify-between">
        <div className="text-left">
          <p className="font-atkinson text-[12px] text-[#8b8b8b]">EMI / Month</p>
          <p className="font-atkinson font-bold text-[12px] mt-[6px] text-[#1b1b1b]">{emiDisplay}</p>
        </div>
        <div className="text-center">
          <p className="font-atkinson text-[12px] text-[#8b8b8b]">Tenure</p>
          <p className="font-atkinson font-bold text-[12px] mt-[6px] text-[#1b1b1b]">{tenureDisplay}</p>
        </div>
        <div className="text-right">
          <p className="font-atkinson text-[12px] text-[#8b8b8b]">Interest</p>
          <p className="font-atkinson font-bold text-[12px] mt-[6px] text-[#1b1b1b]">{interestDisplay}</p>
        </div>
      </div>

      {/* CTA */}
      <button
        disabled={failed}
        id="offer-checked-v17"
        className={
          "w-full font-atkinson font-bold text-[16px] rounded-[16px] py-[16px] mt-[18px] transition-transform " +
          (failed
            ? "bg-[#e8e8e8] text-[#9a9a9a] cursor-not-allowed"
            : "bg-black text-white active:scale-[0.99]")
        }
        onClick={(e) => {
          e.stopPropagation();
          handleClick();
        }}
      >
        I like this
      </button>
    </div>
  );
};

export default React.memo(OfferCard);